import { defineMessages } from 'react-intl';

export const templateListMessages = defineMessages({
  title: {
    id: 'templateList.title',
    defaultMessage: 'Document Templates',
  },
  createTemplate: {
    id: 'templateList.createTemplate',
    defaultMessage: 'Create Template',
  },
  name: { id: 'templateList.name', defaultMessage: 'Name' },
  type: { id: 'templateList.type', defaultMessage: 'Type' },
  all: { id: 'templateList.all', defaultMessage: 'All' },
  language: { id: 'templateList.language', defaultMessage: 'Language' },
  status: { id: 'templateList.status', defaultMessage: 'Status' },
  createdAt: { id: 'templateList.createdAt', defaultMessage: 'Created' },
  modified: { id: 'templateList.modified', defaultMessage: 'Modified' },
  version: { id: 'templateList.version', defaultMessage: 'Version' },
  actions: { id: 'templateList.actions', defaultMessage: 'Actions' },
  noTemplates: {
    id: 'templateList.noTemplates',
    defaultMessage:
      'No templates yet. Create your first template to get started.',
  },
  deleteConfirm: {
    id: 'templateList.deleteConfirm',
    defaultMessage: 'Delete template?',
  },
  deleteConfirmDescription: {
    id: 'templateList.deleteConfirmDescription',
    defaultMessage:
      'After deleting, the template will no longer be available. Are you sure?',
  },
  deleteConfirmAction: {
    id: 'templateList.deleteConfirmAction',
    defaultMessage: 'Yes, delete',
  },
  filterByStatus: {
    id: 'templateList.filterByStatus',
    defaultMessage: 'Filter by status',
  },
  filterByLanguage: {
    id: 'templateList.filterByLanguage',
    defaultMessage: 'Filter by language',
  },
  allStatuses: {
    id: 'templateList.allStatuses',
    defaultMessage: 'All statuses',
  },
  allLanguages: {
    id: 'templateList.allLanguages',
    defaultMessage: 'All languages',
  },
  edit: { id: 'templateList.edit', defaultMessage: 'Edit' },
  view: { id: 'templateList.view', defaultMessage: 'View' },
  delete: { id: 'templateList.delete', defaultMessage: 'Delete' },
  restore: { id: 'templateList.restore', defaultMessage: 'Restore' },
  searchPlaceholder: {
    id: 'templateList.searchPlaceholder',
    defaultMessage: 'Search by name...',
  },
  deleteSuccess: {
    id: 'templateList.deleteSuccess',
    defaultMessage: 'Template deleted successfully',
  },
  createNewSpecialty: {
    id: 'templateList.createNewSpecialty',
    defaultMessage: 'Create Specialty',
  },
  addTemplateToSpecialty: {
    id: 'templateList.addTemplateToSpecialty',
    defaultMessage: 'Add Template',
  },
  ungroupedTemplates: {
    id: 'templateList.ungroupedTemplates',
    defaultMessage: 'Ungrouped Templates',
  },
  noTemplatesInSchema: {
    id: 'templateList.noTemplatesInSchema',
    defaultMessage: 'No templates in this specialty yet',
  },
  documentsCount: {
    id: 'templateList.documentsCount',
    defaultMessage: '{count} templates',
  },
  specialties: {
    id: 'templateList.specialties',
    defaultMessage: 'Specialties',
  },
  allSpecialties: {
    id: 'templateList.allSpecialties',
    defaultMessage: 'All specialties',
  },
  specialty: {
    id: 'templateList.specialty',
    defaultMessage: 'Specialty',
  },
  author: {
    id: 'templateList.author',
    defaultMessage: 'Author',
  },
  templatesForSchema: {
    id: 'templateList.templatesForSchema',
    defaultMessage: 'Templates',
  },
  editSpecialty: {
    id: 'templateList.editSpecialty',
    defaultMessage: 'Edit',
  },
  noSpecialties: {
    id: 'templateList.noSpecialties',
    defaultMessage: 'No specialties created yet. Create one to get started.',
  },
  createSpecialty: {
    id: 'templateList.createSpecialty',
    defaultMessage: 'Create Specialty',
  },
  specialtyPrefix: {
    id: 'templateList.specialtyPrefix',
    defaultMessage: 'Specialty {name}',
  },
  inExistingSpecialty: {
    id: 'templateList.inExistingSpecialty',
    defaultMessage: 'Into existing specialty',
  },
  communityTemplates: {
    id: 'templateList.communityTemplates',
    defaultMessage: 'Community Templates',
  },
  documentTemplates: {
    id: 'templateList.documentTemplates',
    defaultMessage: 'Document Templates',
  },
  noSpecialty: {
    id: 'templateList.noSpecialty',
    defaultMessage: 'Without specialty',
  },
  noTemplatesForFilters: {
    id: 'templateList.noTemplatesForFilters',
    defaultMessage: 'No templates match the selected filters yet.',
  },
  showDeleted: {
    id: 'templateList.showDeleted',
    defaultMessage: 'Show deleted',
  },
  generation: {
    id: 'templateList.generation',
    defaultMessage: 'Generation',
  },
  generationAlways: {
    id: 'templateList.generationAlways',
    defaultMessage: 'Always',
  },
  generationOnDemand: {
    id: 'templateList.generationOnDemand',
    defaultMessage: 'On demand',
  },
  statusActive: {
    id: 'templateList.statusActive',
    defaultMessage: 'Active',
  },
  statusDeleted: {
    id: 'templateList.statusDeleted',
    defaultMessage: 'Deleted',
  },
  showingItems: {
    id: 'templateList.showingItems',
    defaultMessage: 'Showing {from}-{to} of {count} items',
  },
  newestFirst: {
    id: 'templateList.newestFirst',
    defaultMessage: 'Newest first',
  },
  oldestFirst: {
    id: 'templateList.oldestFirst',
    defaultMessage: 'Oldest first',
  },
  analyticsModels: {
    id: 'templateList.analyticsModels',
    defaultMessage: 'Analytics Models',
  },
  analyticsModelsDescription: {
    id: 'templateList.analyticsModelsDescription',
    defaultMessage: 'Configure groups, sections, and tags',
  },
  encounterSchemasUnavailable: {
    id: 'templateList.encounterSchemasUnavailable',
    defaultMessage: 'Specialties are unavailable',
  },
  encounterSchemasUnavailableDescription: {
    id: 'templateList.encounterSchemasUnavailableDescription',
    defaultMessage:
      'Encounter API failed to load the specialties list: {error}. Templates remain available, but specialty grouping is unavailable.',
  },
  encounterSchemasSelectedOnlyDescription: {
    id: 'templateList.encounterSchemasSelectedOnlyDescription',
    defaultMessage:
      'Encounter API failed to load the full specialties list: {error}. Showing only the selected specialty loaded by id.',
  },
  selectedSpecialtyUnavailable: {
    id: 'templateList.selectedSpecialtyUnavailable',
    defaultMessage:
      'The selected specialty could not be loaded from encounter API.',
  },
  addTemplate: {
    id: 'templateList.addTemplate',
    defaultMessage: 'Add Template',
  },
  importTemplate: {
    id: 'templateList.importTemplate',
    defaultMessage: 'Import Template',
  },
  createNew: {
    id: 'templateList.createNew',
    defaultMessage: 'Create New',
  },
  deleteSpecialty: {
    id: 'templateList.deleteSpecialty',
    defaultMessage: 'Delete Specialty',
  },
  deleteSpecialtyConfirm: {
    id: 'templateList.deleteSpecialtyConfirm',
    defaultMessage: 'Delete specialty?',
  },
  deleteSpecialtyConfirmDescription: {
    id: 'templateList.deleteSpecialtyConfirmDescription',
    defaultMessage:
      'After deleting, the specialty will be removed. Templates inside it will not be deleted. Are you sure?',
  },
  deleteSpecialtyConfirmAction: {
    id: 'templateList.deleteSpecialtyConfirmAction',
    defaultMessage: 'Yes, delete',
  },
  deleteSpecialtySuccess: {
    id: 'templateList.deleteSpecialtySuccess',
    defaultMessage: 'Specialty deleted successfully',
  },
  deleteSpecialtyError: {
    id: 'templateList.deleteSpecialtyError',
    defaultMessage: 'Failed to delete specialty',
  },
  deleteError: {
    id: 'templateList.deleteError',
    defaultMessage: 'Failed to delete template',
  },
});
